<template>
  <div v-if="alert" class="my-4">
      <p class="rtl">{{ alert.owner }} עבד/ה על המשרה</p>
      <LinkEntity :payload="alert.resources.position" :additional_data="{ center: true, resource_type: 'Position' }" />
      <br />
      <LinkEntity :payload="alert.resources.company" :additional_data="{ center: true, resource_type: 'Company' }" />
      <div v-if="alert.content" class="mt-4">
        {{ alert.content }}
      </div>
      <br />
      <p class=rtl>במשך {{ alert.duration }} דקות</p>
      <p class=rtl>Created At: {{ this.$moment(alert.created_at).format("DD/MM/YYYY HH:MM") }}</p>
      <br />
      <GhanaFlag :payload="alert.resources.position" :additional_data="{ resource_type: 'Position' }" />
  </div>
</template>
<script>
import LinkEntity from '@/components/LinkEntity'
import GhanaFlag from '@/components/GhanaFlag'

export default {
  name: 'FeedContentReviewPosition',
  components: {
    LinkEntity,
    GhanaFlag
  },
  props: {
    payload: {
      type: Object
    }
  },
  data () {
    return {
      alert: null
    }
  },
  async created () {
    this.alert = await this.$network_utils.getAlert(this.payload.resource_id)
  }
}
</script>
